var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCol',{staticStyle:{"margin-top":"1rem"},attrs:{"xs":"12","sm":"6","xl":"3"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }